import type {LexicalEditor} from 'lexical';

/**
 * Editors whose @mention menu is showing people. While it is, Enter and Tab
 * pick the highlighted person, so form shortcuts (Enter to submit, Tab to the
 * next field) must stand aside. Lexical runs same-priority command listeners
 * in registration order, and the typeahead re-registers its own on every
 * highlight change, so priority alone can't order them.
 */
const openMenus = new WeakSet<LexicalEditor>();

export const setMentionMenuOpen = (editor: LexicalEditor, open: boolean) => {
  if (open) {
    openMenus.add(editor);
  } else {
    openMenus.delete(editor);
  }
};

export const isMentionMenuOpen = (editor: LexicalEditor) => openMenus.has(editor);
